import { getCaseTrackings, getUnservedCaseTrackingRequests, getUnservedCaseTrackingRequestsAll, getTwoPartSearchOrdersAll, getMissingExpectedResults } from '../api/GetCaseTrackings';
const requestCaseTrackingType = 'REQUEST_CASE_TRACKING';
const receiveCaseTrackingType = 'RECEIVE_CASE_TRACKING';

const requestUnservedCaseTrackingRequestsType = 'REQUEST_UNSERVED_CASE_TRACKING_REQUESTS';
const receiveUnservedCaseTrackingRequestsType = 'RECEIVE_UNSERVED_CASE_TRACKING_REQUESTS';

const requestUnservedCaseTrackingRequestsAllType = 'REQUEST_UNSERVED_CASE_TRACKING_REQUESTS_ALL';
const receiveUnservedCaseTrackingRequestsAllType = 'RECEIVE_UNSERVED_CASE_TRACKING_REQUESTS_ALL';

const requestTwoPartSearchOrdersAllType = 'REQUEST_TWO_PART_SEARCH_ORDERS_ALL';
const receiveTwoPartSearchOrdersAllType = 'RECEIVE_TWO_PART_SEARCH_ORDERS_ALL';

const requestMissingExpectedResultsType = 'REQUEST_MISSING_EXPECTED_RESULTS';
const receiveMissingExpectedResultsType = 'RECEIVE_MISSING_EXPECTED_RESULTS';

const initialState = { caseTrackingData: [], unservedCaseTrackingRequests: [], unservedCaseTrackingRequestsAll: [], twoPartSearchOrdersAll: [], missingExpectedResults: [], isLoading: false };

export const actionCreators = {
    requestCaseTracking: (ossId) => async (dispatch, getState) => {

        if (getState().caseTracking.isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: requestCaseTrackingType });

        getCaseTrackings(ossId).then(data => {
            dispatch({ type: receiveCaseTrackingType, caseTrackingData: data });
        }).catch(ex => {
            dispatch({ type: receiveCaseTrackingType, ...initialState, errorMessage: "A server error has occurred. Error Code #2." });
        });
    },

    requestUnservedCaseTrackingRequests: (ossId) => async (dispatch, getState) => {
        //if (getState().caseTracking.isLoading) {
        //    // Don't issue a duplicate request (we already have or are loading the requested data)
        //    return;
        //}

        dispatch({ type: requestUnservedCaseTrackingRequestsType });

        getUnservedCaseTrackingRequests(ossId).then(data => {
            dispatch({ type: receiveUnservedCaseTrackingRequestsType, unservedCaseTrackingRequests: data });
        }).catch(ex => {
            dispatch({ type: receiveUnservedCaseTrackingRequestsType, ...initialState, errorMessage: "A server error has occurred. Code #3." });
        });
    },

    requestUnservedCaseTrackingRequestsAll: () => async (dispatch, getState) => {
        //if (getState().caseTracking.isLoading || getState().caseTracking.unservedCaseTrackingRequests.length > 0) {
        //    // Don't issue a duplicate request (we already have or are loading the requested data)
        //    return;
        //}

        dispatch({ type: requestUnservedCaseTrackingRequestsAllType });

        getUnservedCaseTrackingRequestsAll().then(data => {
            dispatch({ type: receiveUnservedCaseTrackingRequestsAllType, unservedCaseTrackingRequestsAll: data });
        }).catch(ex => {
            dispatch({ type: receiveUnservedCaseTrackingRequestsAllType, ...initialState, errorMessage: "A server error has occurred. Code #4." });
        });
    },

    requestTwoPartSearchOrdersAll: () => async (dispatch, getState) => {
        //if (getState().caseTracking.isLoading || getState().caseTracking.unservedCaseTrackingRequests.length > 0) {
        //    // Don't issue a duplicate request (we already have or are loading the requested data)
        //    return;
        //}

        dispatch({ type: requestTwoPartSearchOrdersAllType });

        getTwoPartSearchOrdersAll().then(data => {
            dispatch({ type: receiveTwoPartSearchOrdersAllType, twoPartSearchOrdersAll: data });
        }).catch(ex => {
            dispatch({ type: receiveTwoPartSearchOrdersAllType, ...initialState, errorMessage: "A server error has occurred. Code #5." });
        });
    },

    requestMissingExpectedResults: () => async (dispatch, getState) => {
        //if (getState().caseTracking.isLoading || getState().caseTracking.unservedCaseTrackingRequests.length > 0) {
        //    // Don't issue a duplicate request (we already have or are loading the requested data)
        //    return;
        //}

        dispatch({ type: requestMissingExpectedResultsType });

        getMissingExpectedResults().then(data => {
            dispatch({ type: receiveMissingExpectedResultsType, missingExpectedResults: data });
        }).catch(ex => {
            dispatch({ type: receiveMissingExpectedResultsType, ...initialState, errorMessage: "A server error has occurred. Code #6." });
        });
    },
};  

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestCaseTrackingType ||
        action.type === requestUnservedCaseTrackingRequestsType ||
        action.type === requestUnservedCaseTrackingRequestsAllType ||
        action.type === requestTwoPartSearchOrdersAllType ||
        action.type === requestMissingExpectedResultsType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveCaseTrackingType || 
        action.type === receiveUnservedCaseTrackingRequestsType ||
        action.type === receiveUnservedCaseTrackingRequestsAllType ||
        action.type === receiveTwoPartSearchOrdersAllType ||
        action.type === receiveMissingExpectedResultsType) {
        return {
            ...state,
            ...action,
            isLoading: false
        };
    }

    return state;
};
